import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { PaymentRequest } from './paymentrequest.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentrequestService {


  constructor(private http: HttpClient, private global: Globle) {
  }


  getAll(status: number) {
    return this.http.get<PaymentRequest[]>(this.global.APIURL + "orderpay?status=" + status);
  }

  Update(updateObj: any) {
    return this.http.put(this.global.APIURL + "orderpay/" + updateObj.id, updateObj)
  }

  // Delete(id:number){
  //   return this.http.delete(this.global.APIURL + "category/" + id)
  // }
}
